import Map from '../map/map';

import { TweenMax, Power3 } from 'gsap';

class MapAside extends Map {
  constructor() {
    super();

    this.dom.map = document.querySelector('.js-map-aside');
    this.dom.mapEl = this.dom.map.querySelector('.js-map-el');
    this.dom.button = this.dom.map.querySelector('.js-toggle');

    this.state = {
      open: false
    };

    this.data = {
      center: {
        lat: 51.453563,
        lng: 5.457784
      }
    };

    this.dom.button.addEventListener('click', this.toggleMap, { passive: true });
  }

  open(el) {
    TweenMax.fromTo(
      el,
      0.3,
      { width: 120 },
      { width: window.innerWidth / 2, Ease: Power3.easeInOut }
    );
  }

  close(el) {
    TweenMax.fromTo(
      el,
      0.3,
      { width: window.innerWidth / 2 },
      { width: 120, Ease: Power3.easeInOut }
    );
  }

  toggleMap = () => {
    if (this.dom.map.offsetWidth <= 120 && this.state.open) this.state.open = false;

    if (!this.state.open) {
      this.open(this.dom.map);
      this.open(this.dom.mapEl);
    }

    if (this.state.open) {
      this.close(this.dom.map);
      this.close(this.dom.mapEl);
    }

    this.state.open = !this.state.open;
    this.dom.map.classList.toggle('map-aside--open');
  }

  destroy = () => {
    this.dom.button.removeEventListener('click', this.toggleMap);
  }

  initMapAside = () => {
    this.init();

    this.state.open = false;


    this.map.setCenter(new window.google.maps.LatLng(this.data.center.lat, this.data.center.lng));
    this.map.setZoom(15);
  }
}

export default MapAside;
